
import React, {useEffect, useState} from "react";
import MusicDashboard from '../../layouts/musicDashboard';
import AccountNav from '../../elements/accountElements/accountNav';

import {useNavigate,  useParams, Link } from "react-router-dom";
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content'
import { showLoading, hideLoading } from 'react-redux-loading-bar';
import {connect} from 'react-redux';
import {isDesktop, isMobile, isTablet, browserName, browserVersion, osName, osVersion, isMobileOnly} from 'react-device-detect';
import CalanderSgv from './../../assets/images/calendar-group.svg';
import PlanLoader from '../../components/loader/planLoader'; 

import * as subscriptionAction from '../../store/subscription/actions'
import * as billingAction from '../../store/billing/actions';
import * as customerAction from '../../store/customer/actions';
import * as couponAction from '../../store/coupon/actions';


const SubscriptionIndex = ({ displayLoading, hideLoading, getCustomerAgreement, agreement, getNotVisibleServices, plans, getUserProfile, cancelSubscription, cancelCustomerFeedback, customerProfile, reactivateSubscription, validateCoupon}) => {

    let match = useParams("/subscription/plans/:id");
    const navigate = useNavigate();

    const MySwal = withReactContent(Swal);
    const [ processing, setProcessing ] = useState(false);
    const [ isStaff, setIsStaff ] = useState(false);
    const [ userDeviceInfo, setUserDeviceInfo ] =  useState({
        device_type: isDesktop ? 'desktop' : isMobile ? 'mobile' : 'tablet',
        browser_name: browserName,
        browser_version: browserVersion,
        os_name: osName,
        os_version: osVersion,
        ip_address: '',
        token: localStorage.user,
        device_id: localStorage.getItem('deviceId')
    });
    
    useEffect(() => { 
		// load Page Data
		loadPageData();
    },[]);
    
    useEffect(() => {
        if(customerProfile && customerProfile.group_id == 3){
            
            var d1 = new Date();
            var d2 = new Date(customerProfile.staff_membership_expire_date);
            if(d2.getTime() > d1.getTime()){
                setIsStaff(true);
            }
        }
    },[customerProfile]);

    const loadPageData = async() => {
        
        setProcessing(true);
        displayLoading();
        await getCustomerAgreement();
        await getNotVisibleServices({subscription_type_id: 1, coupon_code: match.couponCode});
        hideLoading();
        setProcessing(false);
        window.scrollTo({top: 0});
    }

    const cancelCurrentSubscription = async() => {
        
		Swal.fire({
			title: 'Are you sure?',
			text: "You won't be able to revert this!",
			icon: 'warning',
			showCancelButton: true,
			confirmButtonColor: '#ffa800',
			cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, cancel it!',
            cancelButtonText: 'No'
		  }).then((result) => {
			if (result.isConfirmed) {
                displayLoading();
				cancelSubscription().then(res => {
					getCustomerAgreement().then(res => {
						hideLoading();
					});
					Swal.fire({
						title: 'Subscription Canceled',
						text: "Your Subscription has been canceled. No payment will be charged.",
						input: 'text',
						inputAttributes: {
						  autocapitalize: 'off',
						  placeholder: 'Sad to see you go.We would love some constructive feedback!'
						},
						showCancelButton: true,
						confirmButtonText: 'Submit',
						showLoaderOnConfirm: true,
						preConfirm: (message) => {
							if(message != ''){
								sendCustomerCancelFeedback(message)
							}
						},
						allowOutsideClick: () => !Swal.isLoading()
					  }).then((result) => {
						
					  })
				})
			
			} 
		  })
    }

    const unPausedSubscription = async() => {
        await reactivateSubscription().then(res => {
            Swal.fire({
				title: "Unpaused Subscription!", 
				text: "Your subscription reactivated",
				type: "success", 
				closeOnConfirm: true
			}, function(){
                
            });
        })
        await getCustomerAgreement();
        await getUserProfile(userDeviceInfo); 
    }

    const sendCustomerCancelFeedback = (message) => {
        
        cancelCustomerFeedback({message: message}).then(res  => {
			Swal.fire({
				title: "Thank you for your valuable feedback!", 
				text: "Hope to see you soon",
				type: "success", 
				closeOnConfirm: true
			}, function(){
                
            });
        });
    }

    const validateCouponAndRedirect = async(plan) => {
        console.log(plan)
        
        if(plan && plan.coupon){
            await validateCoupon({coupon_code: plan.coupon.coupon_code, subscription_id: plan.id}).then((res)=>{

            })
            // navigate(`/subscription/payment-method/${plan.id}`);
            navigate(`/subscription/stripe-payment-method/${plan.id}`);

        } else {
            // navigate(`/subscription/payment-method/${plan.id}`);
            navigate(`/subscription/stripe-payment-method/${plan.id}`);

        }
    }

    // console.log('agreement', agreement)
    return (
        <MusicDashboard middleSectionCssClass={"account-info-sec full-section"}>
            <div className="content-sec">
                <div className="account-block">
                    <div className="top-heading">
                        <h2>Account Settings</h2>
                    </div>
                    <AccountNav/> 
                    <div className="account-inner-block">
                        {
                            isStaff ? <div className="alert alert-danger">You have landed on wrong page. Please contact to <a href="mailto: info@clubkillers.com" className="primary-color"><b>Support</b></a> for more details</div>
                        :
                            <div className="subscription-sec">
                                {
                                    agreement ?
                                    <div className="top">
                                        
                                        {
                                            agreement.profile_status == 'Active' ?
                                                <div style={{
                                                    background: 'rgba(255, 7, 179, 0.12)',
                                                    border: '1px solid #ff07b3',
                                                    borderRadius: '12px',
                                                    padding: '14px 18px',
                                                    marginBottom: '15px',
                                                    maxWidth: '700px',
                                                    margin: '0 auto 15px'
                                                }}>
                                                    <h5 style={{margin: 0}}>Hi, {customerProfile.dj_name}! You are active on the <span style={{color: '#ff07b3', fontWeight: 700, textTransform: 'capitalize'}}>{agreement.interval}</span> plan{agreement.plan_price ? <> at <span style={{color: '#ff07b3', fontWeight: 700}}>{agreement.plan_price}</span></> : ''}.&nbsp;
                                                    {/* <span className="text-3 cp" onClick={() => cancelCurrentSubscription()}>Cancel Current Plan</span> */}
                                                    <Link className="text-3 cp" to={`/subscription/cancel`}>Cancel Current Plan</Link>
                                                    </h5>
                                                </div>
                                            :
                                            agreement.profile_status == 'CREATED' ?
                                                <div style={{padding: '15% 0'}}>
                                                    <h5 style={{fontSize: '1.5rem', marginBottom: '15px'}}>Hi {customerProfile.dj_name}, Thank you for subscribing!</h5>
                                                    <p style={{maxWidth: '75%', fontSize: '1rem', marginBottom: '15px'}}>We're happy to confirm that your subscription has been created successfully. Please note that it may take up to 24 hours for the payment to be fully processed and reflected in your account.</p>
                                                    <p style={{maxWidth: '75%', fontSize: '1rem', marginBottom: '15px'}}>If you experience any delays beyond this period or have any questions in the meantime, feel free to reach out to <a href="mailto:info@clubkillers.com" className="text-primary" style={{color: '#ff07b3'}}>info@clubkillers.com</a>. We're here to help!</p>
                                                </div>
                                            :
                                            agreement.profile_status == 'Suspend' ?
                                                <h5>Hi, {customerProfile.dj_name}! Your subscription is paused. <span className="text-3 cp" onClick={() => unPausedSubscription()}>Re-activate Current Plan</span></h5>
                                            :
                                            agreement.profile_status == 'Cancelled' ? 
                                                <h5>Hi, {customerProfile.dj_name}! Your subscription has been ended. Subscription again.</h5>
                                            : ''
                                        }
                                        {
                                            agreement.payment_method && agreement.profile_status == 'Active' && customerProfile.payment_profile_status == 'paid' ?
                                                <div style={{
                                                    background: 'rgba(255, 255, 255, 0.04)',
                                                    border: '1px solid rgba(255, 255, 255, 0.12)',
                                                    borderRadius: '12px',
                                                    padding: '16px 20px',
                                                    marginBottom: '15px',
                                                    maxWidth: '700px',
                                                    margin: '0 auto 15px'
                                                }}>
                                                    <h5 style={{margin: 0, lineHeight: '1.6'}}>
                                                    {
                                                        agreement.payment_method == 'Stripe' ?
                                                            agreement.stripe_wallet_type == 'apple_pay' ?
                                                                <>You're paying with Apple Pay. To update your payment method, please change your default card in your Apple Wallet.</>
                                                            :
                                                                <>To update your card on file, please <Link className="text-3 cp" to={`/account/update-card`}>Click Here</Link>.</>
                                                        :
                                                        agreement.payment_method == 'Credit Card' ?
                                                            <>To update your card on file, please <Link className="text-3 cp" to={`/subscription/update-card`}>Click Here</Link>.</>
                                                        :
                                                        agreement.payment_method == 'Paypal' ?
                                                            <>You're paying via PayPal. To update your card, please log in to your <a href="https://www.paypal.com" target="_blank" rel="noopener noreferrer" className="text-3">PayPal account</a> and update your payment method there.</>
                                                        : ''
                                                    }
                                                    </h5>
                                                </div>
                                            : ''

                                        }
                                    </div>
                                    : 
                                    <div className="top">
                                        <h5>Hi, {customerProfile.dj_name}! You haven’t subscribed yet</h5>
                                        <h1>Choose your plan</h1>
                                        <p className="text-3">Create Your Account To Experience The Club Killers Site</p>
                                    </div>
                                }
                                {
                                    agreement.profile_status != 'CREATED' ?
                                
                                <div className="subscription-block">
                                {
                                    processing ? <PlanLoader itemCount="1" /> :
                                        plans && plans.length > 0 ?
                                            plans.map((plan, index) =>{
                                                const intervalDaysByAgreement = {monthly: 30, quaterly: 90, yearly: 365};
                                                const isActiveInterval = agreement && agreement.profile_status == 'Active' && plan.payment_interval == intervalDaysByAgreement[agreement.interval];
                                                return <div className="subscription-box" key={`subscriptionplan${plan.id}`}>
                                                            <div className="inner-block">
                                                                <span className="icon"><img src={CalanderSgv} title=""/></span>
                                                                <h2>{plan.title}</h2>
                                                                <h1>${plan.price}{plan.coupon ? ' - $'+plan.coupon.discount_amount+' = $'+`${plan.price - plan.coupon.discount_amount}` : ''}<span>/{plan.payment_interval == 365 ? 'year': 'month'}</span></h1>
                                                                {
                                                                    plan.trial_price ?
                                                                        <div>
                                                                            <span>${plan.trial_price}</span> First {plan.trial_interval} {plan.trial_period} thereafter <br /> <span>${plan.price}</span> every {plan.payment_interval} {plan.payment_period}
                                                                        </div>
                                                                    :
                                                                        <div className="plan-text">
                                                                            <span>${ plan.coupon ? `${plan.price - plan.coupon.discount_amount}` : plan.price}</span> every {plan.payment_interval} {plan.payment_period}s
                                                                        </div>
                                                                }
                                                                <div dangerouslySetInnerHTML={{__html: plan.features}} className="feature-list"></div>
                                                            </div>
                                                            { 
                                                                plan.is_upgrade_plan == 'yes' ?
                                                                isActiveInterval ? <span className="secondary-btn disabled-btn">Active</span> :
                                                                    <span onClick={() => validateCouponAndRedirect(plan)} className="primary-btn cp">
                                                                        {
                                                                            agreement ?
                                                                                    agreement.profile_status == 'Active' ?
                                                                                        <span>Subscribe to Monthly</span>
                                                                                    :
                                                                                    agreement.profile_status == 'CREATED' ?
                                                                                        <h5>Payment under process</h5>
                                                                                    :
                                                                                    agreement.profile_status == 'Cancelled' ? 
                                                                                        <span>Subscribe to Monthly</span>
                                                                                    : <span>Subscribe to Monthly</span>
                                                                            : 
                                                                            <span>Subscribe</span>
                                                                        }
                                                                    </span> 
                                                                :
                                                                isActiveInterval ? <span className="secondary-btn disabled-btn">Active</span> :
                                                                    <span onClick={() => validateCouponAndRedirect(plan)}  className="primary-btn cp">
                                                                        {
                                                                            agreement ?
                                                                                    agreement.profile_status == 'Active' ?
                                                                                        <span>Subscribe</span>
                                                                                    :
                                                                                    agreement.profile_status == 'CREATED' ?
                                                                                        <h5>Payment under process</h5>
                                                                                    :
                                                                                    agreement.profile_status == 'Cancelled' ? 
                                                                                        <span>Subscribe</span>
                                                                                    : <span>Subscribe</span>
                                                                            : 
                                                                            <span>Subscribe</span>
                                                                        }
                                                                    </span>}
                                                        </div>
                                            })
                                        : ''
                                    }
                                    
                                </div>
                                : ''
                                }
                            </div>
                        }
                    </div>
                </div>
            </div>
        </MusicDashboard>
    );
}
function mapStateToProps(state) {
  return {
	agreement: state.subscription.agreement,
    plans: state.subscription.plans,
    customerProfile: state.customer.customerProfile
  };
}

function mapDispatchToProps(dispatch) {
  	return {
      	getCustomerAgreement: () => dispatch(subscriptionAction.getCustomerAgreement()),
        getNotVisibleServices: (post) => dispatch(subscriptionAction.getNotVisibleServices(post)),
        getUserProfile: (token) => dispatch(customerAction.getCustomerProfile(token)),
		downloadBillingEntry: (post) => dispatch(billingAction.downloadBillingEntry(post)),
		cancelSubscription: () => dispatch(subscriptionAction.cancelSubscription()),
        cancelCustomerFeedback: (post) => dispatch(subscriptionAction.cancelCustomerFeedback(post)),
        reactivateSubscription: () => dispatch(subscriptionAction.reactivateSubscription()),
        displayLoading: (sectionBar) => dispatch(showLoading(sectionBar)),
        hideLoading: (sectionBar) => dispatch(hideLoading(sectionBar)),
        validateCoupon: (post) => dispatch(couponAction.validateCoupon(post)),
  	};
}

export default connect(mapStateToProps, mapDispatchToProps)(SubscriptionIndex);